module.exports = __webpack_public_path__ + "static/media/5.c7ec594f.jpg";